<template>
  <!--内容安全-->
<div class="security" ref="security">
  <a-tabs type="card" @change="tabsChange">
    <a-tab-pane v-for="(item) of tabList" :key="item.key" :tab="item.label">

      <div class="batch-btns">
        <a-checkbox
          ref="normalBtn"
          @click="selectAll"
          :checked="isSelectedAll"
          :indeterminate="indeterminate"
        >全选
        </a-checkbox>
        <a-button
          @click="batchHandleNormal"
          :disabled="!selectedList.length"
          v-hasPermi="['neighbour:security:normal']"
          class="normal"
          type="primary"
          ghost
        >正常
        </a-button>
        <a-button
          @click="batchHandleBlock"
          :disabled="!selectedList.length"
          v-hasPermi="['neighbour:security: illegal']"
          class="block"
          type="danger"
          ghost
        >违规
        </a-button>
      </div>

      <!--删除列表时使用的是rowKey的id-->
      <x-tabula
        apiOrigin="PHP"
        ref="table"
        @resetSearch="resetSearch"
        :dataSource="dataSource"
        rowKey=""
        :searchList="searchList"
        :columns="[]"
        :tableOptList="tableOptList"
        :rowOptList="rowOptList"
        :searchParams.sync="searchParams"
        :listApi="listApi"
        :addHandleParam="addHandleParam"
        :deleteParam="deleteParam"
        :rowSelection="false"
      >
        <ul class="security-content hidden-scrollbar">
          <li class="content-item" v-for="(item, index) of contentList" :key="index">
            <div class="top">
              <span class="time">{{item.create_time}}</span>
              <span class="status" :class="item.status === 2 ? 'green' : 'error'">{{item.status_txt}}</span>
            </div>
            <div class="pic">
              <div v-if="[2, 3].some(el => item.module===el)" @click="openModal(item)" class="mask"></div>
              <!--模块：1.文本 2.图片 3.视频-->
              <img v-if="item.module!==1" :src="item.thumbnail_url" alt="">

              <template v-else>
                <a-tooltip :title="item.content" placement="topLeft">
                <div class="text">{{item.content}}</div>
                </a-tooltip>
              </template>
            </div>
            <div class="txt-box">
            <p class="txt">识别场景：{{item.scene_txt}}</p>
            <p class="txt">违规分类：{{item.category_txt}}</p>
            </div>
            <div class="btns">
              <a-checkbox
                  @click="selectItem(item)"
                  class="checkbox"
                  :checked="item.checked"
                  :disabled="item.status === 3"
              >
                </a-checkbox>
                <div>
                  <!--状态：1.疑似违规 2.正常 3.违规-->
                  <a-button
                    @click="toDetail(item)"
                    v-hasPermi="['neighbour:security:detail']"
                    type="primary"
                    size="small"
                    ghost
                  >查看动态</a-button>
<!--                  :class="{normal: !singleNormal}"-->
                  <a-button
                    v-if="item.status === 1"
                    @click="submitNormal(item.id)"
                    v-hasPermi="['neighbour:security:normal']"
                    type="primary"
                    size="small"
                    ghost
                  >正常</a-button>
                  <a-button
                    v-if="[1, 2].some(ele => item.status === ele)"
                    @click="submitBlock(item.id)"
                    v-hasPermi="['neighbour:security:illegal']"
                    type="danger"
                    ghost
                    size="small"
                  >违规</a-button>
                </div>
            </div>
          </li>
        </ul>
        <!--分页-->
        <a-pagination
          class="pagination"
          :current="paginationParams.current"
          :pageSize="paginationParams.pageSize"
          :total="total"
          showQuickJumper
          show-size-changer
          @change="pageChange"
          @showSizeChange="sizeChange"
          :showTotal="total => { return `共 ${total} 条`; }"
        />
      </x-tabula>
    </a-tab-pane>
  </a-tabs>

  <!--查看内容的弹窗-->
  <a-modal
    :getContainer="() => $refs.security"
    :visible="visible"
    @cancel="visible=false"
    v-bind="$store.state.modalDetailConfig"
    width="auto"
  >
    <div class="modal-content">
      <img class="picture" v-if="contentData.module===2" :src="contentData.content" alt="">
      <video class="video" v-if="contentData.module === 3" :src="contentData.content" controls autoplay></video>
    </div>
  </a-modal>
</div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'security',
  data () {
    return {
      selectedList: [],
      indeterminate: false,
      isSelectedAll: false,
      visible: false,
      contentData: '',
      tabsKey: '2',
      total: 0,
      contentList: [],
      paginationParams: {
        current: 1,
        pageSize: 10
      },
      searchParams: {
        status: 1,
        scene: undefined,
        category: undefined,
        create_date: undefined
      },
      tabList: [
        { label: '图片', key: '2' },
        { label: '视频', key: '3' },
        { label: '文本', key: '1' }
      ],
      batchOptList: [
        { key: 'selectAll' },
        { key: 'batchNormal' },
        { key: 'batchBlock' }
      ],
      singleOptList: [
        { key: 'checkbox' },
        { key: 'detail' },
        { key: 'normal' },
        { key: 'block' }
      ],

      searchList: [
        { props: ['status', {initialValue: 1}], placeholder: '状态', options: [], inputType: 'select' },
        { props: ['scene'], placeholder: '识别场景', options: [], inputType: 'select', handle: this.sceneChange },
        { props: ['category'], placeholder: '分类', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [],
      dataSource: [],
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: this.handleSearchRes
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.getSelect('2');
    this.getSecurityList();
  },
  mounted () {
  },
  methods: {
    getSelect (module, scene) {
      this._get({
        url: '/circle/securitys/selectlist',
        params: {
          module: this.tabsKey || '2', // 默认图片
          scene: scene
        }
      }).then(({data}) => {
        if (module) {
          this.searchList[1].options = data.scenes || [];
        }

        if (scene) {
          this.searchList[2].options = data.categorys || [];
        } else {
          this.searchList[2].options = [];
        }
        this.searchList[0].options = data.status;
      });
    },
    /** 获取安全内容列表 */
    getSecurityList () {
      let params = this.searchParams;
      params.page = this.paginationParams.current;
      params.pagesize = this.paginationParams.pageSize;
      this._get({
        url: `/circle/securitys/${this.tabsKey}`,
        params: params
      }).then(({data}) => {
        this.contentList = data.list;
        this.total = data.total;
      });
    },
    /** 全选 */
    selectAll () {
      this.contentList.forEach((item) => {
        if (item.status !== 3 && !item.checked) {
          this.$set(item, 'checked', true);
          this.selectedList.push({...item});
        } else if (item.checked) {
          this.$set(item, 'checked', false);
          this.selectedList.forEach((part, index) => {
            if (item.id === part.id) {
              this.selectedList.splice(index, 1);
            }
          });
        }
      });

      this.handleIsAll();
    },
    /** 选择单个 */
    selectItem (item) {
      if (!item.checked) {
        this.$set(item, 'checked', true);
        this.selectedList.push({...item});
      } else {
        this.$set(item, 'checked', false);
        this.selectedList.forEach((el, index) => {
          if (el.id === item.id) {
            this.selectedList.splice(index, 1);
          }
        });
      }

      this.handleIsAll();
    },
    /** 判断全选按钮状态 */
    handleIsAll () {
      let {selectedList, contentList} = this;
      if (selectedList.length === 0) {
        this.isSelectedAll = false;
        this.indeterminate = false;
      } else if (selectedList.length > 0 && selectedList.length < contentList.length) {
        this.isSelectedAll = false;
        this.indeterminate = true;
      } else if (selectedList.length === contentList.length) {
        this.isSelectedAll = true;
        this.indeterminate = false;
      }
    },
    /** tab 选择事件 */
    tabsChange (e) {
      this.tabsKey = e;
      this.isSelectedAll = false;
      this.indeterminate = false;
      this.selectedList = [];
      this.getSelect(e);
      this.resetSearch();

      this.searchParams.status = 1;
      this.searchList[0].props[1].initialValue = 1;
    },
    /** 重置搜索 */
    resetSearch () {
      this.searchList[0].props[1].initialValue = undefined;
      this.searchList[2].options = [];
      this.paginationParams.current = 1;
      this.getSecurityList();
    },
    /** 处理搜索 */
    handleSearchRes (param) {
      this.paginationParams.current = 1;
      this.searchParams = param;
      this.getSecurityList();
    },
    /** 修改页码 */
    pageChange (current) {
      this.paginationParams.current = current;
      this.getSecurityList();
    },
    /** 每页展示条数修改 */
    sizeChange (current, size) {
      this.paginationParams.current = current;
      this.paginationParams.pageSize = size;
      this.getSecurityList();
    },
    /** 批量处理为正常 */
    batchHandleNormal () {
      let list = [];
      for (let item of this.selectedList) {
        if (item.status === 1) {
          list.push(item.id);
        }
      }
      this.submitNormal(list);
    },
    /** 提交处理为正常 */
    submitNormal (param) {
      this.$confirm({
        title: '正常确认',
        content: '确定要设置成正常吗？',
        centered: true,
        onOk: (close) => {
          let ids = this.handleParams(param);

          this._post({
            url: '/circle/securitys/normal',
            params: { id: ids }
          }).then(({data}) => {
            close();
            this.$message.success('处理成功');
            this.resetHanlde();
          });
        }
      });
    },
    /** 处理数组或非数组参数 */
    handleParams (param) {
      let ids;
      if (Array.isArray(param)) {
        ids = param.join(',');
      } else {
        ids = param;
      }
      return ids;
    },
    /** 批量处理为违规 */
    batchHandleBlock () {
      // <!--状态：1.疑似违规 2.正常 3.违规-->
      let list = [];
      for (let item of this.selectedList) {
        if ([1, 2].some(ele => item.status === ele)) {
          list.push(item.id);
        }
      }
      this.submitBlock(list);
    },
    /** 提交处理为违规 */
    submitBlock (param) {
      this.$confirm({
        title: '违规确认',
        content: '设置成违规后不可修改，确认此内容违规吗？',
        centered: true,
        onOk: (close) => {
          let ids = this.handleParams(param);

          this._post({
            url: '/circle/securitys/block',
            params: { id: ids }
          }).then(({data}) => {
            close();
            this.$message.success('处理成功');
            this.resetHanlde();
          });
        }
      });
    },
    /** 重置操作 */
    resetHanlde () {
      this.isSelectedAll = false;
      this.indeterminate = false;
      this.selectedList = [];
      this.getSecurityList();
    },
    /** 查看详情 */
    toDetail (item) {
      this.$router.push({
        name: 'dynamicDetail',
        query: { id: item.circle_id, ...this.breadParam(this) }
      });
    },
    /** 打开弹窗 */
    openModal (item) {
      if (item.module === 1) {
        return;
      }
      this.visible = true;
      this.contentData = item;
    },
    /** 场景选择事件 */
    sceneChange (e) {
      empty.$emit('resetForm', ['category']);
      this.getSelect(null, e);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../style/variable";
  .batch-btns {
    margin-bottom: 16px;
    .normal {
      margin-left: 20px;
    }
    .block {
      margin-left: 6px;
    }
  }
  .security-content {
    overflow-y: auto;
    max-height: 910px;
    .content-item {
      padding: 0 14px 10px 14px;
      margin: 4px;
      float: left;
      width: 330px;
      border: 1px solid $gray_1;
      box-shadow: 0 2px 7px 0 $gray_1;
      color: #999;
      .top {
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        .status {
          font-size: 13px;
        }
        .green {
          color: $green_1;
        }
        .error {
          color: $red_1;
        }
      }
      .pic {
        position: relative;
        width: 100%;
        height: 140px;
        cursor: pointer;
        overflow: hidden;
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 20;
          cursor: pointer;
        }
        video,
        img {
          width: 100%;
          height: auto;
        }
        .text {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
        }
      }
      .txt-box {
        line-height: 1.7;
        margin: 10px 0;
      }
      .btns {
        display: flex;
        justify-content: space-between;
        .checkbox {
          margin-right: 24px;
        }
        .ant-btn {
          margin-right: 8px;
        }
        .normal {
          border-color: $green_1;
          color: $green_1;
        }
      }
    }
  }
</style>

<style lang="scss">
  .modal-content {
    .picture,
    .video {
      width: auto;
      height: 600px;
    }
  }
  .pagination {
    margin: 16px 0;
    text-align: right;
  }
</style>
